import { Component } from "react";
import { ToastContainer } from "react-toastify";
import Loader from "../../../utils/Loader";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { getOldPaymentList_action } from "../../../actions/exhibitor_module_actions/accounts_action/update_payment_action";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { toastError, toastSuccess } from "../../../utils/constants"
import moment from "moment";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import AdminDrawer from '../../../common_components/admin_module_drawer';
import { getProformaInvLogList_action, updatePIlog_action } from '../../../actions/admin_module_action/proformaList_action/proformaList_action'
import { data } from "jquery";



class PImodificationList extends Component {

    // Initialize Constructor
    constructor(props) {
        super(props)
        //States
        this.state = {
            isLoading: false,
            loginAccesslist: [],

            // Lists
            modifyPIListData: []

        }
        this.getModifyPIList = this.getModifyPIList.bind(this)
        this.onProceedClick = this.onProceedClick.bind(this)
        this.getWriteAccess = this.getWriteAccess.bind(this)
    }

    componentDidMount() {
        this.getModifyPIList()
        this.setState({ loginAccesslist: JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist'] })
    }

    getWriteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '18');
        if (moduleAccess) {
            return moduleAccess.WriteAccess;
        } else {
            return false
        }
        return false;
    }

    // Get Payment List
    getModifyPIList() {
        this.setState({ isLoading: true })
        this.props.getProformaInvLogList_action()
            .then((data) => {
                if (data.error != 1) {
                    console.log("Payment Listing Data------->", data.data)
                    this.setState({
                        isLoading: false,
                        modifyPIListData: data.data
                    })

                } else {
                    this.setState({ isLoading: false })
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // On Proceed Click
    onProceedClick(e, ExhRegistrationID, ExhibitionID, ExhibitionStallSizeID, StallArea, StallDimension, StallTypeID, isSSICertified) {
        e.preventDefault()
        // this.props.navigate('/receiptentry', { state: { is_add: true, From: "PaymentList", AccountPaymentID: id } })
        this.setState({ isLoading: true })
        this.props.updatePIlog_action(ExhRegistrationID, ExhibitionID, ExhibitionStallSizeID, StallArea, StallDimension, StallTypeID, isSSICertified)
            .then((data) => {
                if (data.error != 1) {
                    console.log("Payment Listing Data------->", data.data)
                    this.setState({ isLoading: false })
                    toastSuccess("Proforma Invoice modified successfully")
                    this.getModifyPIList()

                } else {
                    this.setState({ isLoading: false })
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }


    render() {
        const { isLoading, modifyPIListData } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <AdminDrawer />
                {/*app-content open*/}
                <div className="page">
                    <div className="page-main">
                        <div className="main-content  with-dr-container com-height">
                            <div className="row">
                                {/* <div className="tab-scroll-fixed">
                                <p>Exhibitor Dashboard</p>
                            </div> */}
                                {/* <ExhibitorTopMenu /> */}
                            </div>
                            {/* <div className="card-header mt-0 p-3 mb-2" >
                                <h3 className="card-title" style={{ fontSize: 15 }}>
                                    View / Update Old Payments
                                </h3>
                            </div> */}
                            <div className="row">
                                <div className="step-name-space" style={{ zIndex: "3" }}>
                                    <h6 className="mb-0 px-3 py-2 text-white">
                                        Proforma Invoice List for Modification
                                    </h6>
                                </div>
                            </div>
                            <div className="container-fluid p-2 pt-0">

                                <div className="row mt-4">
                                    <div className="col-xl-12 pt-5">
                                        <div className="card rounded-0 pt-0">

                                            <div className="card-body p-0">
                                                {/* <button
                                                    className="btn btn-dark p-1 mb-2"
                                                    type="btn"
                                                    style={{ float: "right" }}
                                                >
                                                    New payment
                                                </button> */}
                                                <div className="table-responsive mt-4">
                                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th className="text-center">Application No.</th>
                                                                <th>Company Name</th>
                                                                <th className="text-center">Stall Area</th>
                                                                <th className="text-center">Stall Type Name</th>
                                                                <th className="text-center">Country Name</th>
                                                                <th className="text-center">State</th>
                                                                <th className="text-center">Modified Date</th>
                                                                <th className="text-center">Stall Dimensions</th>
                                                                <th style={{ width: 90 }}>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                modifyPIListData.length > 0 && modifyPIListData.map((data) => (
                                                                    <tr>
                                                                        <td className="text-center">{data.ApplicationNo}</td>
                                                                        <td>{data.CompanyName}</td>
                                                                        <td className="text-center">{data.StallArea}sqm</td>
                                                                        <td className="text-center">{data.StallTypeName}</td>
                                                                        <td className="text-center">{data.CountryName}</td>
                                                                        <td className="text-center">{data.State}</td>
                                                                        <td className="text-center">{moment(data.AreaModifiedDate).utc().format('DD-MM-YYYY')}</td>
                                                                        <td className="text-center">{data.ExhibitionStallDimension}</td>
                                                                        <td className="p-1 text-center">
                                                                            <button type="button" className="btn btn-aqua"
                                                                                disabled={!this.getWriteAccess()}
                                                                                onClick={(e) => this.onProceedClick(e, data.ExhRegistrationID, data.ExhibitionID, data.ExhibitionStallSizeID, data.StallArea, data.StallDimension, data.StallTypeID, data.isSSICertified)}
                                                                            >
                                                                                Update
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            }


                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </>

        )
    }
}

export default withRouter(connect(null, { getProformaInvLogList_action, updatePIlog_action })(PImodificationList))
